import { ParticlesBackground } from '@urbantxt/particles';
import React from 'react';
import classes from './AuthCard.module.scss';

interface IProps {
  children: React.ReactNode;
}

function AuthCard({ children }: IProps) {
  return (
    <div className={classes.container}>
      <ParticlesBackground />
      <div className={classes.card}>{children}</div>
    </div>
  );
}

export default AuthCard;
